const config = {
  apiUrl: "https://apiinflow.maverixgroup.co.th/api",
  baseUrl: "/",
  imgUrl: "https://apiinflow.maverixgroup.co.th/",
};
export default config;
